import { Box, Link, Stack, Typography, useMediaQuery } from "@mui/material";

import { EVOTRUX_BRAND_GREEN, SUPPORT_EMAIL } from "constants/index";
import { useRoleContext } from "hooks";
import { buildCarrierVerificationMailtoLink } from "utils";

import { BANNER_TEXT_MIN_WIDTH } from "../../constants";

export function UnverifiedCarrierBanner() {
  const showText = useMediaQuery(BANNER_TEXT_MIN_WIDTH);
  const { company } = useRoleContext();
  const companyName = company?.name ?? "Your Company";
  const mailToLink = buildCarrierVerificationMailtoLink(companyName);

  return (
    <Box>
      {showText && (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          gap={1}
          width="100%"
        >
          <Typography variant="h6" color="white">
            Send your insurance to{" "}
            <Link
              href={mailToLink}
              fontWeight="bold"
              color={EVOTRUX_BRAND_GREEN}
            >
              {SUPPORT_EMAIL}
            </Link>{" "}
            to get verified.
          </Typography>
        </Stack>
      )}
    </Box>
  );
}
